<template>
    <div>
        <h2>{{ $t("settings.smart-routing.basic-info.header") }}</h2>

        <validation-provider #default="{ errors }" name="name" rules="required">
            <b-form-group
                id="fieldset-name"
                :description="$t('settings.smart-routing.basic-info.name.description')"
                :label="$t('settings.smart-routing.basic-info.name.label')"
                :state="errors.length > 0 ? false : null"
                content-cols-lg="7"
                content-cols-sm
                label-cols-lg="3"
                label-cols-sm="4"
                label-for="name"
            >
                <b-form-input
                    id="name"
                    v-model="currentRoute.name"
                    :state="errors.length > 0 ? false : null"
                    type="text"
                />
                <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
        </validation-provider>
    </div>
</template>
<script>
import { BFormGroup, BFormInput } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import { required } from "@validations";
import useRoutes from "@/views/modules/settings/smart-routing/useRoutes";

export default {
    components: {
        BFormGroup,
        BFormInput,
        ValidationProvider,
    },
    setup() {
        const { currentRoute } = useRoutes();

        return {
            currentRoute,
        };
    },
};
</script>
